import { render, staticRenderFns } from "./TransferPopup.vue?vue&type=template&id=70b954dd&scoped=true&"
import script from "./TransferPopup.vue?vue&type=script&lang=js&"
export * from "./TransferPopup.vue?vue&type=script&lang=js&"
import style0 from "./TransferPopup.vue?vue&type=style&index=0&id=70b954dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b954dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDialog,VRow})
